import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class DomainAddressRegistration extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Domain Address Registration"
					title={"domain address registration"}
					image={require('./image-3.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Domain Address Registration
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							

								<p>Registering a domain name (address) can be incredibly overwhelming for a new business owner. </p>

								<h4>We specialise in making the domain registration process easier for you.</h4>


								<p>The Moshi Moshi team can give you advice on your company name itself, how your domain name will affect your page rank and SEO, and manage your registration and web hosting services. 

</p>
<p>Your URL extension also requires consideration - if you’re targeting audiences on a national level, you should have a .com.au. However, if you’re targeting at a global level, .com is the better option. Moshi Moshi can guide you through all of these decisions to create the best domain and business name for you. </p>

<br></br>
<hr></hr>							
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-hosting">Website Hosting</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/custom-programmed-systems">Custom Programmed Systems</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/brand-and-logo-design">Brand and Logo Design</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-marketing">Email Newsletter Marketing</a>

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>
<h3> If you have a new business you’re considering starting, get in touch with the team at Moshi Moshi and we can get you moving in the right direction. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default DomainAddressRegistration;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/DomainAddressRegistration.js